"use strict";
// https://coderwall.com/p/i817wa/one-line-function-to-detect-mobile-devices-with-javascript
// ... don't use mobile detection unless you ABSOLUTELY HAVE to
Object.defineProperty(exports, "__esModule", { value: true });
var isMobile = (typeof window.orientation !== 'undefined') ||
    (navigator.userAgent.indexOf('IEMobile') !== -1);
exports.default = isMobile;
//# sourceMappingURL=is-mobile.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/is-mobile.js
// module id = w1dv
// module chunks = 20 21 22